import { render, staticRenderFns } from "./ProductGroupDialogContent.vue?vue&type=template&id=f9cce984"
import script from "./ProductGroupDialogContent.vue?vue&type=script&lang=js"
export * from "./ProductGroupDialogContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports